"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoutes from "./ProtectedRoutes";

interface ProtectedLayoutProp {
  children: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProp> = ({ children }) => {
  const [client] = React.useState(new QueryClient());
  return (
    <QueryClientProvider client={client}>
      <ProtectedRoutes>
        {children}
      </ProtectedRoutes>
      <ToastContainer
        position="bottom-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </QueryClientProvider>
  );
};

export default ProtectedLayout;
